export enum AbStatus {
  None = 'None',
  VariantA = 'VariantA',
  VariantB = 'VariantB'
}
